import React, { useEffect, useState } from "react";
import axios from "axios";
// import "../css/restaurant_inventory.css";
import { useNavigate } from "react-router-dom";
import { FaUtensils, FaShoppingCart } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const API = "https://api.mahal.qa/api/inventory";
const CART_API = "https://api.mahal.qa/api/cart/add";

const RestaurantInventory = () => {

  const restaurantId = localStorage.getItem("linked_id");
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Issue modal
  const [selectedItem, setSelectedItem] = useState(null);
  const [issueQty, setIssueQty] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [issuing, setIssuing] = useState(false);

  // Reorder modal
  const [reorderItemData, setReorderItemData] = useState(null);
  const [reorderQty, setReorderQty] = useState(1);
  const [reordering, setReordering] = useState(false);

  const [search, setSearch] = useState("");
  const [stockFilter, setStockFilter] = useState("ALL");
  // Inside component
  const { t, i18n } = useTranslation();
  const formatNumber = (value) => {
  return new Intl.NumberFormat(
    i18n.language === "ar" ? "ar-QA" : "en-US"
  ).format(value);
};


  /* ================= FETCH INVENTORY ================= */
  useEffect(() => {
    if (!restaurantId) return;

    axios
      .get(`${API}/restaurant/stock?restaurant_id=${restaurantId}`)
      .then(res => {
        console.log(res.data);
        setItems(res.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));

  }, [restaurantId, i18n.language]);


  /* ================= SUMMARY ================= */
  const totalQty = items.reduce(
    (sum, i) => sum + Number(i.available_qty || 0),
    0
  );

  const lowStockCount = items.filter(
    i => Number(i.available_qty) > 0 && Number(i.available_qty) < 10
  ).length;


  if (loading) return <div className="inv-loading">{t("ResloadingInventory")}</div>;


  /* ================= FILTER ================= */
  const filteredItems = items.filter(item => {

    const qty = Number(item.available_qty || 0);

const name =
  i18n.language === "ar"
    ? (item.product_name_arabic || item.product_name || "").toLowerCase()
    : (item.product_name || "").toLowerCase();
    const query = search.trim().toLowerCase();

    const matchesSearch = name.includes(query);

    const matchesStock =
      stockFilter === "ALL" ||
      (stockFilter === "IN" && qty >= 10) ||
      (stockFilter === "LOW" && qty > 0 && qty < 10) ||
      (stockFilter === "OUT" && qty <= 0);

    return matchesSearch && matchesStock;

  });


  /* ================= REORDER CONFIRM ================= */
  const confirmReorder = async () => {
    try {

      const token = localStorage.getItem("token");

      if (!token) {
        alert("Please login first");
        return;
      }

      setReordering(true);

      await axios.post(
        CART_API,
        {
          product_id: reorderItemData.product_id,
          quantity: reorderQty,
          price: Number(reorderItemData.price || 0)
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      alert("Added to cart");
      setReorderItemData(null);

      navigate("/cartview");

    } catch (err) {
      console.error(err);
      alert("Failed to reorder");
    } finally {
      setReordering(false);
    }
  };


  return (


<div className="dashboard_page">

  {/* Header */}


<div class="page_header">
<div class="review_title">
<div class="review_title_icon">
<i class=" fas fa-box-open"></i>
</div>
<div>
 <h2>{t("ResrestaurantInventory")}</h2>
        <p>{t("ResrealTimeStock")}</p>
</div>
</div>
</div>

  {/* Filters */}

  <div className="inventory_filters">

    <div className="search_box">

      <i className="fas fa-search"></i>

      <input
        type="text"
        placeholder={t("RessearchProduct")}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

    </div>

    <select
      value={stockFilter}
      onChange={(e) => setStockFilter(e.target.value)}
    >
      <option value="ALL">{t("Resall")}</option>
      <option value="IN">{t("ResinStock")}</option>
      <option value="LOW">{t("ReslowStock")}</option>
      <option value="OUT">{t("ResoutOfStock")}</option>
    </select>

  </div>

  {/* Stats */}
    <div className="section_card soft mb-3">
        <div className="row">

          {/* Supplier */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon supplier">
                <i className="fas fa-box"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                 {t("RestotalProducts")}
                </small>

                <div className="grn-info-value">
                  {formatNumber(items.length)}
                 <small>All Items</small>
                </div>
              </div>
            </div>
            
          </div>

      
          {/* Received By */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon user">
                <i className="fas fa-layer-group"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                  {t("RestotalQuantity")}
                </small>

                <div className="grn-info-value">
               {formatNumber(totalQty.toFixed(2))}
            <small>Items In Stock</small>
                </div>
              </div>
            </div>
          </div>

          {/* GRN Date */}
          <div className="col-md-4">
            <div className="grn-info-item">
              <div className="grn-info-icon date">
                <i className="fas fa-exclamation-triangle"></i>
              </div>

              <div className="grn-info-content">
                <small className="muted">
                 {t("ReslowStock")}
                </small>

                <div className="grn-info-value">
                  {formatNumber(lowStockCount)}
                   <small>Need Attention</small>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

  {/* Products */}

  <div className="inventory_grid">

    {filteredItems.map((item) => {

      const qty = Number(item.available_qty || 0);

      let status = t("ResinStock");
      let statusClass = "stock_ok";

      if (qty <= 0) {
        status = t("ResoutOfStock");
        statusClass = "stock_danger";
      } else if (qty < 10) {
        status = t("ReslowStock");
        statusClass = "stock_warning";
      }

      return (

        <div
          className={`product_card ${statusClass}`}
          key={item.product_id}
        >

          <div className="issue-product-image">

            <img
              src={
                item.product_image
                  ? `data:image/png;base64,${item.product_image}`
                  : "/placeholder-product.png"
              }
              alt=""
            />

          </div>

          <h5>
            {i18n.language === "ar"
              ? item.product_name_arabic?.trim() ||
                item.product_name_english
              : item.product_name_english}
          </h5>

          {/* <div className="product_qty">
            {formatNumber(qty.toFixed(2))}
          </div> */}
          <div className="action_icons">
            <span className="stock-badge">
            {formatNumber(qty.toFixed(2))}
          </span>
            {/* {formatNumber(qty.toFixed(2))} */}
            <span className={`stock_badge ${statusClass}`}>
            {status}
          </span>
          </div>

          
<div className="action_icons">
          <button
            className="btn_issue"
            disabled={qty <= 0}
            onClick={() => {
              setSelectedItem(item);
              setIssueQty(1);
              setRemarks("");
            }}
          >
            <FaUtensils />
            {t("ResissueToKitchen")}
          </button>

          <button
            className="btn_reorder"
            onClick={() => {
              const suggested = qty < 10 ? 20 - qty : 10;
              setReorderItemData(item);
              setReorderQty(suggested);
            }}
          >
            <FaShoppingCart />
            {t("Resreorder")}
          </button>

        </div>
 </div>
      );

    })}
  </div>

</div>
  );
};

export default RestaurantInventory;
